import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Apple, Smartphone, Download, QrCode, Monitor, Tablet } from 'lucide-react';

const DownloadPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);
  const appFeatures = [
    {
      icon: '📱',
      title: 'Trade on the Go',
      description: 'Access your account and trade from anywhere, anytime'
    },
    {
      icon: '⚡',
      title: 'Real-time Updates',
      description: 'Get instant notifications and live market data'
    },
    {
      icon: '🤖',
      title: 'AI Auto-Trading',
      description: 'Fully automated trading with advanced algorithms'
    },
    {
      icon: '🔔',
      title: 'Price Alerts',
      description: 'Set custom alerts for your favorite assets'
    },
    {
      icon: '💰',
      title: 'Quick Deposits',
      description: 'Deposit and withdraw funds instantly'
    },
    {
      icon: '🔒',
      title: 'Secure & Safe',
      description: 'Bank-level security with biometric authentication'
    }
  ];

  const handleDownload = (platform) => {
    // Placeholder for APK download links
    alert(`${platform} app download will be available soon! App will soon be on Play Store.`);
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      
      <main className="pt-24 pb-20">
        {/* Hero Section */}
        <section className="relative py-20 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-yellow-900/20 to-black animate-pulse"></div>
          <div className={`relative z-10 max-w-7xl mx-auto px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              {/* Left Content */}
              <div>
                <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-in-down">
                  Download <span className="text-yellow-500">PreciseFx</span> App
                </h1>
                <p className="text-xl text-gray-400 mb-8 animate-fade-in-up animate-delay-200">
                  Trade anywhere, anytime with our powerful mobile app. Available for iOS and Android.
                </p>

                {/* Download Buttons */}
                <div className="space-y-4 mb-8 animate-fade-in-left animate-delay-300">
                  {/* iOS Download */}
                  <a href="https://users.spreadex.asia" target="_blank" rel="noopener noreferrer">
                  <button

                    className="w-full sm:w-auto bg-gradient-to-r from-gray-900 to-black border-2 border-gray-700 hover:border-yellow-500 rounded-xl p-4 flex items-center space-x-4 transition-all duration-300 hover-scale hover-glow"
                  >
                    <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center">
                      <Apple className="w-8 h-8 text-black" />
                    </div>
                      <div className="text-left">
                        <div className="text-sm text-gray-400">Download on the</div>
                        <div className="text-xl font-bold">App Store</div>
                      </div>
                    
                  </button></a>

                  {/* Android Download */}
                  <button
                    onClick={() => handleDownload('Android')}
                    className="w-full sm:w-auto bg-gradient-to-r from-gray-900 to-black border-2 border-gray-700 hover:border-yellow-500 rounded-xl p-4 flex items-center space-x-4 transition-all duration-300 hover-scale hover-glow"
                  >
                    <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-green-600 rounded-xl flex items-center justify-center">
                      <Smartphone className="w-8 h-8 text-white" />
                    </div>
                    <div className="text-left">
                      <div className="text-sm text-gray-400">Get it on</div>
                      <div className="text-xl font-bold">Google Play</div>
                    </div>
                  </button>

                  {/* APK Direct Download */}
                  <a
                    href="https://admin.spreadex.asia/api/downloads/tenant-apk/MOB_D002FEC3B8"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full sm:w-auto bg-yellow-500 hover:bg-yellow-600 text-black rounded-xl p-4 flex items-center justify-center space-x-3 transition-all duration-300 hover-scale font-bold animate-glow"
                  >
                    <Download className="w-6 h-6" />
                    <span>Download Android App</span>
                  </a>
                </div>

                {/* QR Code Section */}
                <div className="bg-gradient-to-br from-gray-900 to-black rounded-xl p-6 border border-gray-800 inline-block hover-lift animate-fade-in-left animate-delay-500">
                  <div className="flex items-center space-x-4">
                    <div className="bg-white p-4 rounded-lg animate-pulse">
                      <QrCode className="w-24 h-24 text-black" />
                    </div>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Scan QR Code</p>
                      <p className="font-semibold">Download instantly</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right - Phone Mockup */}
              <div className="relative flex justify-center animate-fade-in-right animate-delay-400">
                <div className="relative">
                  {/* Glow effect */}
                  <div className="absolute inset-0 bg-yellow-500/30 blur-3xl rounded-full animate-pulse"></div>
                  
                  {/* Phone mockup */}
                  <div className="relative bg-gradient-to-b from-gray-900 to-black rounded-[3rem] p-4 border-4 border-gray-800 shadow-2xl w-80 h-[600px] transform hover:scale-105 transition-transform duration-500 animate-float">
                    <div className="bg-black rounded-[2.5rem] h-full overflow-hidden">
                      {/* App Screenshot Placeholder */}
                      <div className="h-full bg-gradient-to-b from-gray-950 to-black flex flex-col">
                        {/* Top bar */}
                        <div className="flex items-center justify-between p-4 border-b border-gray-800">
                          <div className="flex items-center space-x-2">
                            <div className="w-8 h-8 bg-yellow-500 rounded-full"></div>
                            <div>
                              <div className="text-xs text-gray-400">BALANCE</div>
                              <div className="text-sm font-bold">$10,000.00</div>
                            </div>
                          </div>
                          <button className="bg-yellow-500 text-black px-3 py-1 rounded-lg text-xs font-semibold">+</button>
                        </div>

                        {/* Trading pairs */}
                        <div className="p-4 space-y-2">
                          <div className="bg-gray-900 rounded-lg p-3 flex items-center justify-between">
                            <div className="flex items-center space-x-2">
                              <span>💱</span>
                              <span className="font-semibold">EUR/USD</span>
                            </div>
                            <span className="text-yellow-500">+0.45%</span>
                          </div>
                          <div className="bg-gray-900 rounded-lg p-3 flex items-center justify-between">
                            <div className="flex items-center space-x-2">
                              <span>₿</span>
                              <span className="font-semibold">BTC/USD</span>
                            </div>
                            <span className="text-yellow-500">+2.34%</span>
                          </div>
                          <div className="bg-gray-900 rounded-lg p-3 flex items-center justify-between">
                            <div className="flex items-center space-x-2">
                              <span>🏆</span>
                              <span className="font-semibold">GOLD</span>
                            </div>
                            <span className="text-red-500">-0.12%</span>
                          </div>
                        </div>

                        {/* Chart area */}
                        <div className="flex-1 p-4">
                          <div className="h-full bg-gradient-to-b from-gray-900 to-black rounded-xl flex items-end justify-around p-4">
                            {[40, 60, 45, 70, 55, 80, 65, 75].map((height, i) => (
                              <div
                                key={i}
                                className={`w-2 ${i % 2 === 0 ? 'bg-red-500' : 'bg-yellow-500'} rounded-sm`}
                                style={{ height: `${height}%` }}
                              ></div>
                            ))}
                          </div>
                        </div>

                        {/* Bottom navigation */}
                        <div className="flex items-center justify-around p-4 border-t border-gray-800">
                          <button className="flex flex-col items-center text-yellow-500">
                            <div className="text-xl mb-1">📊</div>
                            <span className="text-xs">Trade</span>
                          </button>
                          <button className="flex flex-col items-center text-gray-400">
                            <div className="text-xl mb-1">📈</div>
                            <span className="text-xs">Markets</span>
                          </button>
                          <button className="flex flex-col items-center text-gray-400">
                            <div className="text-xl mb-1">💼</div>
                            <span className="text-xs">Portfolio</span>
                          </button>
                          <button className="flex flex-col items-center text-gray-400">
                            <div className="text-xl mb-1">⚙️</div>
                            <span className="text-xs">Settings</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* App Features */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-4 animate-scale-in">
            Everything You Need in <span className="text-yellow-500">One App</span>
          </h2>
          <p className="text-center text-gray-400 text-lg mb-12 animate-fade-in-up animate-delay-200">
            Powerful features designed for traders on the move
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {appFeatures.map((feature, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-900 to-black rounded-xl p-8 text-center border border-gray-800 hover:border-yellow-500 transition-all duration-300 hover-lift hover-glow animate-fade-in-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="text-5xl mb-4 animate-float">{feature.icon}</div>
                <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Platform Comparison */}
        <section className="bg-gradient-to-b from-black via-gray-900 to-black py-20">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 animate-scale-in">
              Available on <span className="text-yellow-500">All Platforms</span>
            </h2>

            <div className="grid md:grid-cols-3 gap-8">
              {/* Mobile */}
              <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 text-center border border-gray-800 hover-lift hover-glow animate-fade-in-up">
                <div className="w-20 h-20 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-4 animate-float">
                  <Smartphone className="w-10 h-10 text-yellow-500" />
                </div>
                <h3 className="text-2xl font-bold mb-4">Mobile App</h3>
                <ul className="text-left space-y-2 text-gray-300">
                  <li className="flex items-center"><span className="text-yellow-500 mr-2">✓</span> iOS & Android</li>
                  <li className="flex items-center"><span className="text-yellow-500 mr-2">✓</span> Push Notifications</li>
                  <li className="flex items-center"><span className="text-yellow-500 mr-2">✓</span> Biometric Login</li>
                  <li className="flex items-center"><span className="text-yellow-500 mr-2">✓</span> AI Trading 24/7</li>
                </ul>
              </div>

              {/* Web */}
              <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 text-center border border-gray-800 hover-lift hover-glow animate-fade-in-up animate-delay-100">
                <div className="w-20 h-20 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-4 animate-float">
                  <Monitor className="w-10 h-10 text-yellow-500" />
                </div>
                <h3 className="text-2xl font-bold mb-4">Web Platform</h3>
                <ul className="text-left space-y-2 text-gray-300">
                  <li className="flex items-center"><span className="text-yellow-500 mr-2">✓</span> No Download Required</li>
                  <li className="flex items-center"><span className="text-yellow-500 mr-2">✓</span> All Browsers</li>
                  <li className="flex items-center"><span className="text-yellow-500 mr-2">✓</span> Advanced Tools</li>
                  <li className="flex items-center"><span className="text-yellow-500 mr-2">✓</span> Multi-monitor Support</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* System Requirements */}
        <section className="max-w-5xl mx-auto px-6 py-20">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            System Requirements
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            {/* iOS */}
            <div className="bg-gradient-to-br from-gray-900 to-black rounded-xl p-8 border border-gray-800">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center">
                  <Apple className="w-8 h-8 text-black" />
                </div>
                <h3 className="text-2xl font-bold">iOS Requirements</h3>
              </div>
              <ul className="space-y-2 text-gray-300">
                <li>• iOS 12.0 or later</li>
                <li>• iPhone, iPad, and iPod touch</li>
                <li>• 50 MB free space</li>
                <li>• Internet connection required</li>
              </ul>
            </div>

            {/* Android */}
            <div className="bg-gradient-to-br from-gray-900 to-black rounded-xl p-8 border border-gray-800">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-green-400 to-green-600 rounded-xl flex items-center justify-center">
                  <Smartphone className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold">Android Requirements</h3>
              </div>
              <ul className="space-y-2 text-gray-300">
                <li>• Android 6.0 or later</li>
                <li>• All Android devices</li>
                <li>• 50 MB free space</li>
                <li>• Internet connection required</li>
              </ul>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="max-w-5xl mx-auto px-6 py-20">
          <div className="bg-gradient-to-r from-yellow-900/30 to-gray-900 rounded-2xl p-12 text-center hover-glow animate-scale-in">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 animate-fade-in-down">
              Start Trading Today
            </h2>
            <p className="text-xl text-gray-300 mb-8 animate-fade-in-up animate-delay-200">
              Download the app and get instant access to global markets
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up animate-delay-400">
              <Button 
                onClick={() => handleDownload('iOS')}
                className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold text-lg px-8 py-6 rounded-xl hover-scale animate-glow"
              >
                Download for iOS
              </Button>
              <a
                href="https://admin.spreadex.asia/api/downloads/tenant-apk/MOB_D002FEC3B8"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold text-lg px-8 py-6 rounded-xl hover-scale animate-glow">
                  Download for Android
                </Button>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DownloadPage;
